module.exports = __webpack_public_path__ + "assets/icons/window.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/window.svg
// module id = rDim
// module chunks = 1